import { HolderOutlined } from "@ant-design/icons";
import { SourceType } from "dnd-core";
import { useDrag } from "react-dnd";

export interface DragHandleProps<T> {
  type: SourceType;
  item: T;
}

export const DragHandle = <T extends object>({ type, item }: DragHandleProps<T>) => {
  const [, drag] = useDrag({ type, item });

  return (
    <div ref={drag} style={{ textAlign: "center", cursor: "grab" }}>
      <HolderOutlined/>
    </div>
  );
};
